import * as v from "valibot";
import { rpcContract } from "../rpc";

export const reactivateLiveEventRpcContract = rpcContract({
  name: "reactivate-live-event",
  paramsSchema: v.object({
    event_id: v.string(),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    message: v.optional(v.string()),
  }),
});

export type ReactivateLiveEventParams = v.InferOutput<(typeof reactivateLiveEventRpcContract)["paramsSchema"]>;
export type ReactivateLiveEventResult = v.InferOutput<(typeof reactivateLiveEventRpcContract)["resultSchema"]>;
